import type { SolutionType } from '@app/src/types/resourceExplorer'

export enum BenchmarkGroupType {
  Network = 'Network',
  Country = 'Country',
  Region = 'Region',
  Industry = 'Industry',
  SubIndustry = 'SubIndustry',
  RevenueRange = 'RevenueRange',
}

interface BenchmarkStatsRow {
  id: number
  createdAt?: string
  periodName: string
  groupType: BenchmarkGroupType
  groupValue?: string
  solutionType: SolutionType
  min: number
  max: number
  mean: number
  median: number
  count: number
}

export interface AssessmentBenchmark extends BenchmarkStatsRow {
  // Undefined identifies a "global" row: a TotalScore row whose stats span every qualifying
  // assessment template for the group, rather than a single template.
  assessmentTemplateId?: number
  assessmentTemplate?: { id: number; name: string }
  assessmentTemplateSectionId?: number
  assessmentTemplateSection?: { id: number; name: string }
  assessmentIds: number[]
}

export interface FindingsBenchmark extends BenchmarkStatsRow {
  // Undefined identifies a "global" row: a row whose stats span every qualifying questionnaire
  // template for the group, rather than a single template.
  questionnaireTemplateId?: number
  questionnaireTemplate?: { id: number; title: string }
  responseScrapingIds: number[]
}
